import { defineComponent as _defineComponent } from 'vue'
import type { SiffletButtonSize } from '@/components/SButton/SButton.vue';

type SiffletThreeDotMenuButtonVariant = 'outlined' | 'text'

interface Props {
  /**
   * Whether the menu is disabled or not.
   */
  disabled?: boolean;
  /**
   * Button variant (`outlined` or `text`). `outlined` by default.
   */
  variant?: SiffletThreeDotMenuButtonVariant;
  /**
   * data-track attribute for testing purposes.
   */
  dataTrack?: string;
  size?: SiffletButtonSize;
}

import { defineComponent as __MACROS_defineComponent } from "vue";
const __default__ = __MACROS_defineComponent({
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SThreeDotMenu',
  props: {
  disabled: { type: Boolean, default: false },
  variant: { default: 'outlined' },
  dataTrack: null,
  size: { default: 'default' }
},
  setup(__props) {


// "elevated" does not make sense for a three-dot menu button


;

return { __sfc: true,__MACROS_defineComponent }
}

})